import React, {useCallback, useContext, useEffect, useState} from "react";
import {
    Button,
    Card,
    CardContent,
    CardMedia, Checkbox, CircularProgress,
    FormControlLabel, FormGroup, ListItem, Menu, MenuItem,
    Switch, Tab,
    TextField
} from "@mui/material";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import IconButton from "@mui/material/IconButton";
import currencyList from "../../../sampleData/currencyList";
import {useGoogleAutocompleteUniversal} from "../../Helpers/GoogleAutocomplete";

import usePA_GlobalStore from "../../../Services/ZustandGlobalStore";
import {useDropzone} from "react-dropzone";
import dayjs from "dayjs";
import {DatePicker} from "@mui/x-date-pickers";
import * as pdfjsLib from "pdfjs-dist";
import {CloudUpload as CloudUploadIcon} from "@mui/icons-material";
import PALocation from "../../../MasterEventObjects/Location";
import Grid from "@mui/material/Grid";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import {PAContext} from "../../../Services/PAContext";
import {getAllContactsFromDatabase} from "../../Restricted/Contacts/BrowserDatabaseFunctions";


const extractTextFromPDF = async (data) => {
    const loadingTask = pdfjsLib.getDocument({ data });
    const pdf = await loadingTask.promise;
    let fullText = "";

    for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const textContent = await page.getTextContent();
        const pageText = textContent.items.map(item => item.str).join(" ");
        fullText += pageText + "\n";
    }
    return fullText;
};

// --- LanguageModel API ---
const LanguageModel = window.LanguageModel || {
    availability: async () => 'available',
    create: async (options) => ({
        prompt: async (text) => `💡 Prompt response: "${text}"`,
        translate: async (text) => `🌎 Translated text: "${text}"`,
        rewrite: async (text) => `📝 Proofread text: "${text}"`,
        summarize: async (text) => `💡 Summarizer response: "${text}"`,
    }),
};
function extractJsonFromText(str) {
    if (!str) return { json: null, text: str };

    // Strip markdown code blocks
    let cleanedStr = str.replace(/```json/g, "").replace(/```/g, "").trim();

    const firstBrace = cleanedStr.indexOf("{");
    const lastBrace = cleanedStr.lastIndexOf("}");

    if (firstBrace !== -1 && lastBrace !== -1) {
        const jsonStr = cleanedStr.slice(firstBrace, lastBrace + 1).trim();
        let parsedJson = null;
        try {
            parsedJson = JSON.parse(jsonStr);
        } catch (e) {
            console.error("JSON Parse Error", e);
        }

        const textBefore = cleanedStr.slice(0, firstBrace).trim();
        const textAfter = cleanedStr.slice(lastBrace + 1).trim();
        const remainingText = [textBefore, textAfter].filter(Boolean).join("\n").trim();

        return { json: parsedJson, text: remainingText || null };
    }

    return { json: null, text: str };
}
const formatDateForInput = (dateStr) => {
    if (!dateStr || dateStr === "Not found") return "";

    // If it's already yyyy-MM-dd, return it
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dateStr;

    const date = new Date(dateStr);

    // Check if the date is actually valid before formatting
    if (!isNaN(date.getTime())) {
        return date.toISOString().split('T')[0];
    }

    return "";
};





function ReceiptsAddNewCard({key, receipt, updateReceipt, removeReceipt}){

    const { PA_GlobalObject, set_PA_GlobalObject } = usePA_GlobalStore();

    const { dataArray } = useContext(PAContext);
    const { SampleAttendees, authenticated } = dataArray; // Fetch event attendees

    const [dbContacts, setDbContacts] = useState([]);
    useEffect(() => {
        if (!authenticated) {
            setDbContacts([]);
            return;
        }

        let cancelled = false;

        getAllContactsFromDatabase()
            .then(contacts => {
                if (cancelled) return;
                setDbContacts(Array.isArray(contacts) ? contacts : []);
            })
            .catch(err => {
                console.error('Failed to load Contacts from browser DB:', err);
                if (!cancelled) {
                    setDbContacts([]);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [authenticated]);
    const [ attendeesReferenceArray, setAttendeesReferenceArray ] = useState( authenticated
        ? dbContacts
        : SampleAttendees);

    useEffect(() => {

        console.log("authenticated, dbContacts, SampleAttendees triggered ...");

        setAttendeesReferenceArray(
            authenticated
                ? dbContacts
                : SampleAttendees
        );
    }, [authenticated, dbContacts, SampleAttendees]);


    const [ eventReceipt, setEventReceipt ] = useState(receipt);
    const [selectedAction, setSelectedAction] = useState("");
    const [receiptTabSelected, setReceiptTabSelected] = useState("");
    const [uniqueLocations, setUniqueLocations] = useState([]);
    const [receiptLocation, setReceiptLocation] = useState(eventReceipt.location);

    useEffect(() => {
        // Add `locationGroup` to each item
        const meals = (PA_GlobalObject.Planning.meals || []).map(meal => ({
            ...meal,
            locationGroup: 'Meals'
        }));

        const lodging = (PA_GlobalObject.Planning.lodging || []).map(lodge => ({
            ...lodge,
            locationGroup: 'Lodging'
        }));

        const activities = (PA_GlobalObject.Planning.activities || []).map(activity => ({
            ...activity,
            locationGroup: 'Activities'
        }));

        const savedReceipts = (PA_GlobalObject.Planning.receipts || []).map(r => ({
            ...r,
            locationGroup: 'Receipts'
        }));

        // Combine all locations
        const allLocations = [
            ...meals.map(meal => ({ ...meal.location, locationGroup: 'Meals' })),
            ...lodging.map(lodge => ({ ...lodge.location, locationGroup: 'Lodging' })),
            ...activities.map(activity => ({ ...activity.location, locationGroup: 'Activities' })),
            ...savedReceipts.map(r => ({ ...(r.location || r), locationGroup: 'Receipts' })),
        ];

        // Filter unique locations by Google Place ID or another unique property
        const unique = Array.from(
            new Map(
                allLocations
                    .filter(location => location.name && location.google_place_id) // Exclude locations without a name
                    .map((location) => [location.google_place_id, location])
            ).values()
        );

        // Sort the unique locations alphabetically by name
        const sortedUnique = unique.sort((a, b) => {
            const nameA = (a.name || "").toLowerCase();
            const nameB = (b.name || "").toLowerCase();
            return nameA.localeCompare(nameB);
        });

        // Separate the matching location from the rest
        const matchingLocation = sortedUnique.filter(
            (location) =>
                receiptLocation &&
                location.google_place_id === receiptLocation.google_place_id
        );

        const otherLocations = sortedUnique.filter(
            (location) =>
                !receiptLocation ||
                location.google_place_id !== receiptLocation.google_place_id
        );

        // Combine matching location(s) on top with the rest alphabetically sorted
        const finalLocationList = [...matchingLocation, ...otherLocations];

        console.log("finalLocationList : ",finalLocationList);

        setUniqueLocations(finalLocationList);
    }, []);

    useEffect(() => {
        updateReceipt(eventReceipt);
    }, [eventReceipt]);

    const handleFooterItemClick = (_item) => {
        setSelectedAction(_item);
        receiptTabSelected === _item ? setReceiptTabSelected("") : setReceiptTabSelected(_item);
    };

    /*
        for the receipt location
     */

    // State for location
    const [tabValueLocation, setTabValueLocation] = useState("locations");
    const handleTabLocationChange  = (event, newValue) => {
        console.log("handleTabLocationChange ");
        setTabValueLocation(newValue);
    };


    // State for location
    function handleLocationSelect(location) {
        setEventReceipt(prev => ({
            ...prev,
            location: location
        }));
    }


    const parseV2Address = (place) => {
        let _address_line = "", _address_city = "", _address_state = "", _address_zip = "", _address_country = "";
        const components = place.addressComponents || [];
        const _country_comp = components.find(c => c.types.includes("country"));
        const _country_code = _country_comp?.shortText || "";

        components.forEach((component) => {
            const types = component.types;
            const val = component.longText;
            if (types.includes("street_number")) _address_line = val;
            else if (types.includes("route")) _address_line = _address_line ? `${_address_line} ${val}` : val;
            else if (types.includes("locality")) _address_city = val;
            else if (types.includes("administrative_area_level_1")) _address_state = (_country_code === "US") ? component.shortText : val;
            else if (types.includes("postal_code")) _address_zip = val;
            else if (types.includes("country")) _address_country = component.shortText;
        });

        if (!_address_line && place.formattedAddress) {
            _address_line = place.formattedAddress.split(',')[0].trim();
        }
        return { _address_line, _address_city, _address_state, _address_zip, _address_country };
    };
    const handleUniversalSelect = (place, isBusiness) => {
        console.log("the selected Place 111: ", place.toJSON());

        const parsedAddr = parseV2Address(place);
        console.log("the parsedAddr 111: ", parsedAddr);
        // Shared Location Object Mapper
        const mapToPALocation = (place, parsed) => {
            const loc = new PALocation();
            loc.google_place_id = place.id;
            loc.latitude = typeof place.location?.lat === 'function' ? place.location.lat() : place.location?.lat;
            loc.longitude = typeof place.location?.lng === 'function' ? place.location.lng() : place.location?.lng;
            loc.name = place.displayName?.text || place.displayName;
            loc.formatted_address = place.formattedAddress;
            loc.address = parsed._address_line;
            loc.city = parsed._address_city;
            loc.state = parsed._address_state;
            loc.zip = parsed._address_zip;
            loc.country = parsed._address_country;
            loc.phone = place.internationalPhoneNumber || "";
            loc.types = place.types || [];
            loc.hours = place.regularOpeningHours?.weekdayDescriptions || [];
            loc.website = place.websiteURI || "";
            loc.price_level = place.priceLevel;
            loc.rating = place.rating;
            loc.total_ratings = place.userRatingCount;

            console.log("the selected address : ", loc);
            return loc;
        };

        setEventReceipt(prev => ({
            ...prev,
            location: mapToPALocation(place, parsedAddr)
        }))

    };
    const {
        containerRef: locationRef,
        initAutocomplete: initUniversal,
        autocompleteInstance
    } = useGoogleAutocompleteUniversal(handleUniversalSelect);

    useEffect(() => {
        // try to (re)initialize/append the autocomplete
        if (tabValueLocation === "search" && locationRef.current) {
            initUniversal();
        }
    }, [tabValueLocation, locationRef.current]);
    const handleLocationFieldChange = (field) => (e) => {
        const value = e.target.value;
        setEventReceipt(prev => ({
            ...prev,
            location: {
                ...prev?.location,
                [field]: value
            }
        }));

    };



    /*
        for the receipt link
     */
    // Get event lodging, meals, and activities
    const eventLodging = PA_GlobalObject.Planning.lodging || [];
    const eventMeals = PA_GlobalObject.Planning.meals || [];
    const eventActivities = PA_GlobalObject.Planning.activities || [];
    const eventFlights = PA_GlobalObject.Planning.flights || [];
    const eventReceipts = PA_GlobalObject.Planning.receipts || [];

    function handleReceiptLinkChange(section_id, _section) {
        console.log("handleReceiptLinkChange");

        //if the section id is -1 then no need to look anything up
        if (section_id === -1 || (eventReceipt.section === _section && eventReceipt.section_item === section_id)){
            setEventReceipt(prev => ({
                ...prev,
                section: prev.section === _section && prev.section_item === section_id ? "General" : _section,
                section_item: "",
            }))
        } else {
            const categoryLookup = {
                Lodging: eventLodging.find((lodging) => lodging.id === section_id),
                Meals: eventMeals.find((meal) => meal.id === section_id),
                Activities: eventActivities.find((activity) => activity.id === section_id),
                Flights: eventFlights.find((flight) => flight.id === section_id),
            };

            const selectedCategory = categoryLookup[_section];

            console.log("selectedCategory : ", selectedCategory);

            if (selectedCategory) {
                let _amount = selectedCategory.amount_total; // Preserve existing amount
                let _currency = selectedCategory.currency; // Preserve existing currency
                let _location = selectedCategory.location; // Preserve existing location
                let _date_of_service = selectedCategory.date; //preserve existing date

                // Find the matching attendee (any kind, not just business expense)
                const matchingAttendee = selectedCategory.attendees?.find(
                    (att) => att.id === eventReceipt.attendee_id
                );

                _amount = matchingAttendee ? parseFloat(matchingAttendee.cost || matchingAttendee.amount_total || 0) : _amount;

                //If the selected category has time_table.date[0] data, update it
                if (selectedCategory.time_table?.dates?.[0]){
                    _date_of_service = selectedCategory.time_table.dates[0].date;
                    setReceiptServiceDate(selectedCategory.time_table.dates[0].date);
                }

                // If the selected category has location data, update it
                if (selectedCategory.location) {
                    _location = {
                        google_place_id: selectedCategory.location.google_place_id || "",
                        latitude: selectedCategory.location.latitude || 0,
                        longitude: selectedCategory.location.longitude || 0,
                        name: selectedCategory.location.name || "",
                        formatted_address: selectedCategory.location.formatted_address || "",
                        address: selectedCategory.location.address || "",
                        city: selectedCategory.location.city || "",
                        state: selectedCategory.location.state || "",
                        zip: selectedCategory.location.zip || "",
                        country: selectedCategory.location.country || "",
                        phone_prefix: selectedCategory.location.phone_prefix || "",
                        phone: selectedCategory.location.phone || "",
                    };
                }

                handleLocationSelect(_location);

                setEventReceipt(prev => ({
                    ...prev,
                    section: _section,
                    section_item: section_id,
                    amount: _amount,
                    currency: _currency,
                    date: _date_of_service
                }))
            }
        }
    }




    /*
        for the receipt amount
     */
    const [anchorChangeCurrencyEl, setAnchorChangeCurrencyEl] = useState(null);
    const handleChangeCurrencyClick = (event, code) => {
        console.log("changing currency to : "+code);
        const _new_currency_code = code;
        setEventReceipt(prevState => ({
            ...prevState,
            currency: _new_currency_code
        }));

        handleChangeCurrencyClose();
    };
    const handleChangeCurrencyClose = () => {
        setAnchorChangeCurrencyEl(null);
    };
    const [receiptServiceDate, setReceiptServiceDate] = useState('');
    useEffect(() => {
        setEventReceipt(prevState => ({
            ...prevState,
            date: receiptServiceDate
        }));
    }, [receiptServiceDate]);
    const [editModeBusinessExpense, setEditModeBusinessExpense] = useState(false);



    /*
        for the receipt photo
     */
    const [receiptFile, setReceiptFile] = useState({});
    const [useExperimentalAi, setUseExperimentalAi] = useState(false);
    const [imageData, setImageData] = useState(null);
    const [aiSession, setAiSession] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false); // true while AI is working
    const [aiResults, setAiResults] = useState(null);        // JSON from AI
    const [aiError, setAiError] = useState(null);
    const [selectedKeys, setSelectedKeys] = useState({});    // track checkboxes
    const [appliedAiResults, setAppliedAiResults] = useState({}); // final applied data
    const [chatMessages, setChatMessages] = useState([]);
    const [followUpPrompt, setFollowUpPrompt] = useState("");  // the text the user will type
    const [isFollowUpProcessing, setIsFollowUpProcessing] = useState(false); // track AI follow-up


    // Process AI Receipts (Only runs if AI is enabled)
    useEffect(() => {
        console.log("useExperimentalAi");

        // Explicitly check if the global AI API exists in this browser window first
        if (typeof window === 'undefined' || !window.ai || !window.ai.languageModel) {
            console.warn("Experimental AI LanguageModel is not supported in this browser.");
            return;
        }

        if (!aiSession) {
            console.log("!! checking capabilities and creating the session");

            const initSession = async () => {
                try {
                    // 1. Check if the model is ready, needs a download, or is entirely unsupported
                    const capabilities = await window.ai.languageModel.capabilities();

                    console.log("capabilities : ", capabilities);

                    if (capabilities.available === 'no') {
                        console.warn("Language model is not available on this device.");
                        return;
                    }

                    // If it returns 'after-download', it means the service is downloading the model
                    // in the background. You might want to handle this state to show a loader.
                    if (capabilities.available === 'after-download') {
                        console.log("Model is downloading... waiting for service to spin up.");
                    }

                    // 2. Safely attempt creation
                    const session = await window.LanguageModel.create({
                        expectedInputs: [
                            { type: 'image', languages: ['en'] },
                            { type: 'text', languages: ['en'] }
                        ],
                        expectedOutputs: [{ type: 'text', languages: ['en'] }]
                    });

                    setAiSession(session);
                    console.log("AI Session successfully created!");

                } catch (error) {
                    // 3. Catch the NotSupportedError gracefully if the service stalls
                    console.error("Failed to spin up local AI session:", error.message);

                    // Fallback: retry after a short delay or notify your UI state
                    if (error.name === 'NotSupportedError') {
                        console.log("Service is likely warming up or downloading. Will retry on next toggle.");
                    }
                }
            };

            initSession();
        }

    }, [aiSession]); // 💡 Changed dependency array to monitor the session itself!
    useEffect(() => {
        if (aiSession){
            processReceiptWithAI();
        }
    }, [aiSession, imageData]);

    const processReceiptWithAI = async (passedData = null) => {
        // Priority 1: Data passed directly from onDrop
        // Priority 2: Data stored in component state
        const dataToUse = passedData || imageData;

        if (useExperimentalAi && dataToUse) {
            setIsProcessing(true);
            setAiError(null);

            try {
                let contentPart;

                // --- BRANCH 1: PLAIN TEXT (EML or Scraped PDF Text) ---
                if (typeof dataToUse === 'string' && !dataToUse.startsWith('data:')) {
                    // --- IMPROVED EML/TEXT HANDLING ---
                    // Strip out excessive headers to save tokens and focus the AI
                    const cleanText = dataToUse
                        .replace(/Received:[\s\S]*?\r?\n(?!\s)/g, '') // Remove routing headers
                        .replace(/Authentication-Results:[\s\S]*?\r?\n(?!\s)/g, '')
                        .trim();

                    const MAX_CHARS = 15000;
                    contentPart = {
                        type: 'text',
                        value: cleanText.length > MAX_CHARS
                            ? `ANALYZE THIS EMAIL CONTENT:\n${cleanText.substring(0, MAX_CHARS)}` + "\n\n[... TRUNCATED ...]"
                            : `ANALYZE THIS EMAIL CONTENT:\n${cleanText}`
                    };
                }
                // --- BRANCH 2: BINARY DATA (Images or PDF Fallbacks) ---
                else if (typeof dataToUse === 'string' && dataToUse.startsWith('data:')) {

                    // 1. Convert the DataURL (Base64) into a Blob as required by the AI Guidance
                    const response = await fetch(dataToUse);
                    const blob = await response.blob();
                    const mimeType = blob.type;

                    if (mimeType === 'application/pdf') {
                        // If extraction failed, send as much of the raw string as the AI context allows
                        // without triggering the 'Input too large' quota error.
                        const safeLimit = 10000;
                        const fallbackValue = dataToUse.length > safeLimit
                            ? dataToUse.substring(0, safeLimit) + "\n[TRUNCATED]"
                            : dataToUse;

                        contentPart = {
                            type: 'text',
                            value: `FALLBACK DATA (PDF): ${fallbackValue}`
                        };
                        console.warn(`PDF scraper was bypassed. Sending ${fallbackValue.length} chars of raw data to AI.`);
                    } else {
                        // SUCCESS: Send as a BLOB, exactly like the documentation shows
                        contentPart = {
                            type: 'image',
                            value: blob
                        };
                    }
                }

                // Execute the AI Prompt
                const apiResponse = await aiSession.prompt([
                    {
                        role: 'user',
                        content: [
                            {
                                type: 'text',
                                value: `You are a specialized expense parser. Analyze this document and return a JSON object.

                                    ### CATEGORIES:
                                    Lodging, Meals, Activities, Flights, Transportation, Supplies, Incidentals, Shopping, General.
                                    
                                    ### EXTRACTION RULES:
                                    1. **Category**: Choose the best fit from the list above.
                                    2. **Dates**: 
                                       - "receiptDate": The transaction/payment date (YYYY-MM-DD).
                                       - For **Lodging**: Find "Check-in" and "Check-out" dates. Add keys "startDate" and "endDate".
                                       - For **Activities**: Find "Date of Service". Add key "serviceDate".
                                    3. **Financials**:
                                       - "grandTotal": Final amount. RETURN AS A NUMERIC STRING ONLY (e.g., "1354.80"). Remove all symbols like $ or commas.
                                       - "currency": Identify the 3-letter currency code (e.g., "USD", "EUR", "GBP").
                                       - "amountDue": Set to "0.00" if paid in full or if change is 0.
                                    4. **Location Breakdown**:
                                       - Do not provide a single address string. Split it into "businessAddress" (Street), "businessCity", "businessState", "businessZip", and "businessCountry".
                                    
                                    ### OUTPUT FORMAT:
                                    Return ONLY a valid JSON object. Use "Not found" for missing fields. 
                                    Include: 
                                    "category", "currency", "businessName", "businessAddress", "businessCity", "businessState", "businessZip", 
                                    "businessCountry", "businessPhone", "businessEmail", "businessWebsite", "receiptID", "receiptDate", "grandTotal", "amountDue", 
                                    "bookedThrough", "confirmationCode", "reservationName", "reservationNumber", "notes".
                                    
                                    IMPORTANT: Do not hallucinate. If you don't see a field, return "Not found".`
                            },
                            contentPart
                        ],
                    },
                ]);

                console.log("AI Raw Response:", apiResponse);

                // --- DEFENSIVE PARSING START ---
                if (!apiResponse || apiResponse.trim() === "") {
                    throw new Error("AI_EMPTY_RESPONSE");
                }

                const cleaned = cleanAiJsonString(apiResponse);
                const parsedResult = JSON.parse(cleaned);

                // Safety check: Ensure parsedResult is an actual object and not null
                if (parsedResult && typeof parsedResult === 'object') {
                    setAiResults(parsedResult);

                    const defaultSelected = {};
                    Object.keys(parsedResult).forEach(key => {
                        defaultSelected[key] = true;
                    });
                    setSelectedKeys(defaultSelected);
                } else {
                    throw new Error("INVALID_JSON_STRUCTURE");
                }

            } catch (error) {
                console.error("AI Session Prompt Error:", error);

                let errorDisplay = "I ran into an error while analyzing the file.";
                if (error.name === "QuotaExceededError" || error.message?.includes("large")) {
                    errorDisplay = "⚠️ This file is too large for the local AI.";
                } else if (error.message?.includes("Unsupported image type") || error.name === "SyntaxError") {
                    errorDisplay = "⚠️ Format Error: Ensure you are uploading a valid image or PDF.";
                }

                setAiError(errorDisplay);
                setChatMessages(prev => [...prev, { role: "ai", content: errorDisplay }]);
            } finally {
                setIsProcessing(false);
            }
        }
    };
    const onDrop = useCallback((acceptedFiles) => {
        acceptedFiles.forEach(async (file) => {
            const fileName = file.name.toLowerCase();
            const isEml = fileName.endsWith(".eml");
            const isPdf = file.type === "application/pdf";

            const validTypes = [
                "image/jpg", "image/jpeg", "image/png", "image/gif", "image/webp",
                "application/pdf", "message/rfc822", "application/octet-stream"
            ];

            if (!validTypes.includes(file.type) && !isEml) {
                console.error(`Skipped "${file.name}" due to an invalid file type: ${file.type}`);
                return;
            }

            const reader = new FileReader();

            reader.onload = async () => {
                const determinedType = isEml ? "message/rfc822" : file.type;
                console.log("determinedType :", determinedType);
                const fileContent = reader.result; // This is DataURL for images/PDF, Text for EML

                let dataForAi = fileContent;

                // --- PDF TEXT EXTRACTION BRANCH ---
                if (isPdf) {
                    try {
                        // Convert DataURL to ArrayBuffer for pdf.js
                        const response = await fetch(fileContent);
                        const arrayBuffer = await response.arrayBuffer();
                        const extractedText = await extractTextFromPDF(arrayBuffer);

                        dataForAi = `EXTRACTED PDF TEXT:\n${extractedText}`;
                        console.log("PDF Text Extracted, length:", dataForAi.length);
                    } catch (pdfError) {
                        console.error("PDF Text Extraction failed:", pdfError);
                        // Fallback to sending the raw string if extraction fails
                        dataForAi = fileContent;
                    }
                }

                // Update application states
                setEventReceipt(prev => ({
                    ...prev,
                    file_name: file.name,
                    file_type: determinedType,
                    file_size: file.size,
                    full_data: fileContent // Keep original DataURL for previewing in UI
                }));

                setReceiptFile({
                    name: file.name,
                    type: determinedType,
                    size: file.size,
                    full_data: fileContent,
                    private: false,
                });

                setImageData(dataForAi);

                // Trigger AI with extracted text or image data
                console.log("dataForAi :", dataForAi);
                processReceiptWithAI(dataForAi);
            };

            if (isEml) {
                reader.readAsText(file);
            } else {
                reader.readAsDataURL(file);
            }
        });
    }, [setEventReceipt, setReceiptFile, setImageData, processReceiptWithAI]);
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        maxFiles: 1,
        accept: {
            "image/jpg": [],
            "image/jpeg": [],
            "image/png": [],
            "image/gif": [],
            "image/webp": [],
            "application/pdf": [],
            "message/rfc822": [".eml"],
            "application/octet-stream": [".eml"] // Fallback to ensure .eml is selectable
        },
    });
    function cleanAiJsonString(str) {
        if (!str) return null;

        // Remove ```json and ``` code fences if present
        str = str.replace(/```json/g, "").replace(/```/g, "").trim();

        // Try to find JSON braces
        const firstBrace = str.indexOf("{");
        const lastBrace = str.lastIndexOf("}");

        if (firstBrace !== -1 && lastBrace !== -1) {
            return str.slice(firstBrace, lastBrace + 1).trim();
        }

        // No braces found — return the string as-is (plain text)
        return str.length > 0 ? str : null;
    }
    function renderValue(value) {
        if (typeof value === "object" && value !== null) {
            return (
                <Box sx={{ ml: 1 }}>
                    {Object.entries(value).map(([k, v]) => (
                        <Box key={k}>
                            <strong>{k}:</strong> {renderValue(v)}
                        </Box>
                    ))}
                </Box>
            );
        }
        return value;
    }
    const applyAiDataToReceipt = () => {
        const rawAmount = aiResults.grandTotal || "0";
        const cleanAmount = typeof rawAmount === 'string'
            ? rawAmount.replace(/[$,\s]/g, "")
            : rawAmount;

        setEventReceipt(prev => ({
            ...prev,
            section: aiResults.category || prev.section,
            amount: cleanAmount,
            currency: aiResults.currency || prev.currency,
            date: aiResults.receiptDate || prev.date,
            notes: aiResults.notes || prev.notes,
            receipt_id: aiResults.receiptID || prev.receipt_id,

            // Linking Metadata
            confirmation_code: aiResults.confirmationCode || "",
            booked_through: aiResults.bookedThrough || "",
            reservation_name: aiResults.reservationName || "",
            reservation_number: aiResults.reservationNumber || "",

            location: {
                ...prev.location,
                name: aiResults.businessName || prev.location.name,
                address: aiResults.businessAddress || prev.location.address,
                city: aiResults.businessCity || prev.location.city,
                state: aiResults.businessState || prev.location.state,
                zip: aiResults.businessZip || prev.location.zip,
                country: aiResults.businessCountry || prev.location.country,
                phone: aiResults.businessPhone || prev.location.phone,
                website: aiResults.businessWebsite || prev.location.website,
                email: aiResults.businessEmail || prev.location.email,
            },
            is_business_expense: false,
            business_expense_amount: 0,
        }));

        setReceiptServiceDate(aiResults.receiptDate || "");
        setNotes(aiResults.notes || "");
        setAiResults(null);
    };



    /*
        for the receipt notes
    */
    const [ notes, setNotes ] = useState("");
    useEffect(() => {
        setEventReceipt(prev => ({
            ...prev,
            notes: notes
        }))
    }, [notes]);


    const sectionOptions = ['Lodging', 'Meals', 'Activities', 'Flights', 'Transportation', 'Supplies', 'Incidentals', 'Shopping', 'General'];
    const [anchorEl, setAnchorEl] = useState(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleSelect = (newSection) => {

        /*
            changing category will break any section_item link
            so we have to alert for that
         */

        setEventReceipt(prev => ({
            ...prev,
            section: newSection,
            section_item: ""
        }));
        handleClose();
    };
    const tabIcons = [
        { key: 'Location', icon: 'icon-map-marker', label: 'Location', color: '#ff6f61' },
        { key: 'Link', icon: 'icon-link', label: 'Link', color: '#d4af37' },
        { key: 'Amount', icon: 'icon-wallet', label: 'Amount', color: '#2e8b57' },
        { key: 'Photo', icon: 'icon-picture2', label: 'Photo', color: '#4ec3f3' },
        { key: 'Notes', icon: 'icon-pencil2', label: 'Notes', color: '#6c757d' },
    ];



    return (

        <Card
            id={key}
            sx={{
                borderRadius: '5px',
                border: '1px solid #f09637',
                marginTop: '10px'
            }}
        >

            {/*
                    this is the main content area with the icons down
                    the left side and the meal content on the right
                 */}
            <Box sx={{display: "flex", width: "100%"}}>

                <Box
                    sx={{
                        minWidth: "55px", // a bit wider for label readability
                        backgroundColor: 'rgb(249, 249, 249)',
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        padding: "8px 0",
                        borderRight: "1px solid #e0e0e0",
                    }}
                >
                    {tabIcons.map(({ key, icon, label, color }) => (
                        <Box
                            key={key}
                            onClick={() => handleFooterItemClick(key)}
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginBottom: '12px',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                transform: receiptTabSelected === key ? 'scale(1.05)' : 'scale(1)',
                            }}
                        >
                            <IconButton
                                sx={{
                                    backgroundColor: receiptTabSelected === key ? `${color}20` : 'transparent',
                                    borderRadius: '10px',
                                    padding: '6px',
                                    transition: 'background-color 0.2s ease-in-out',
                                }}
                            >
                                <i
                                    className={icon}
                                    style={{
                                        fontSize: '18px',
                                        color: receiptTabSelected === key ? color : '#428ce2',
                                    }}
                                />
                            </IconButton>
                            <Typography
                                variant="caption"
                                sx={{
                                    fontSize: '10px',
                                    textAlign: 'center',
                                    color: receiptTabSelected === key ? color : '#428ce2',
                                    fontWeight: receiptTabSelected === key ? '600' : '400',
                                }}
                            >
                                {label}
                            </Typography>
                        </Box>
                    ))}

                    {/* add the delete icon */}
                    <Box
                        onClick={() => removeReceipt(receipt.id)}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginBottom: '12px',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            transform: 'scale(1)',
                        }}
                    >
                        <IconButton
                            sx={{
                                backgroundColor: 'transparent',
                                borderRadius: '10px',
                                padding: '6px',
                                transition: 'background-color 0.2s ease-in-out',
                            }}
                        >
                            <i
                                className="icon-trash"
                                style={{
                                    fontSize: '18px',
                                    color: "#F00",
                                }}
                            />
                        </IconButton>
                        <Typography
                            variant="caption"
                            sx={{
                                fontSize: '10px',
                                textAlign: 'center',
                                color: '#F00',
                                fontWeight: '400',
                            }}
                        >
                            Delete
                        </Typography>
                    </Box>
                </Box>

                {/* DYNAMIC METADATA CONTROLLER AREA */}
                <Box sx={{ flexGrow: 1, position: 'relative', pb: '48px' }}>
                    {/* Show CardMedia or File Placeholder */}
                    {eventReceipt.file_type ? (
                        eventReceipt.file_type.startsWith("image/") ? (
                            <CardMedia
                                component="img"
                                height="140"
                                image={eventReceipt.full_data}
                                alt={eventReceipt.file_name}
                                sx={{ objectFit: 'contain', bgcolor: '#f5f5f5' }}
                            />
                        ) : (
                            <Box
                                sx={{
                                    height: 140,
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    backgroundColor: "#f7f9fc",
                                    borderBottom: "1px solid #e1e8ed",
                                    gap: 1
                                }}
                            >
                                {eventReceipt.file_type.includes("pdf") ? (
                                    <i className="icon-doc" style={{ fontSize: '40px', color: '#d32f2f' }} />
                                ) : eventReceipt.file_type.includes("rfc822") || eventReceipt.file_name?.endsWith('.eml') ? (
                                    <i className="icon-envelope-letter" style={{ fontSize: '40px', color: '#1976d2' }} />
                                ) : (
                                    <i className="icon-drawer" style={{ fontSize: '40px', color: '#607d8b' }} />
                                )}

                                <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary', px: 2, textAlign: 'center' }}>
                                    {eventReceipt.file_name}
                                </Typography>
                            </Box>
                        )
                    ) : null}

                    {/* HEADER BLOCK: Category Selector, Business Badge & Total Amount */}
                    <Box sx={{ padding: '16px 16px 0 16px' }}>
                        <Box display="flex" justifyContent="space-between" alignItems="flex-start" sx={{ width: "100%" }}>
                            {/* Left Column: Category and Business Badge Stack */}
                            <Box display="flex" flexDirection="column" gap={0.75} alignItems="flex-start">
                                <Box
                                    display="flex"
                                    alignItems="center"
                                    gap={1}
                                    onClick={handleClick}
                                    sx={{
                                        cursor: 'pointer',
                                        p: '4px 10px',
                                        borderRadius: '6px',
                                        backgroundColor: 'rgba(16, 49, 143, 0.05)',
                                        '&:hover': { backgroundColor: 'rgba(16, 49, 143, 0.1)' }
                                    }}
                                >
                                    <i
                                        className={
                                            eventReceipt.section === "Flights" ? "icon-airplane" :
                                                eventReceipt.section === "Lodging" ? "icon-bed" :
                                                    eventReceipt.section === "Meals" ? "icon-fork-knife2" : "icon-helm"
                                        }
                                        style={{ color: '#10318f' }}
                                    />
                                    <Typography variant="body2" sx={{ fontWeight: 700, color: '#10318f' }}>
                                        {eventReceipt.section || "General"}
                                    </Typography>
                                    <i className="icon-chevron-down" style={{ fontSize: '10px', color: '#10318f', opacity: 0.7 }} />
                                </Box>

                                {/* 💼 Business Expense Indicator Badge */}
                                {eventReceipt.is_business_expense && (
                                    <Box
                                        sx={{
                                            backgroundColor: '#e8f5e9',
                                            color: '#2e7d32',
                                            border: '1px solid #c8e6c9',
                                            borderRadius: '4px',
                                            px: 1,
                                            py: 0.25,
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 0.5
                                        }}
                                        title={eventReceipt.business_expense_reference_id ? `Ref: ${eventReceipt.business_expense_reference_id}` : 'Business Expense'}
                                    >
                                        <Typography sx={{ fontSize: '10px', fontWeight: 800, letterSpacing: '0.3px', textTransform: 'uppercase' }}>
                                            💼 Business
                                        </Typography>
                                    </Box>
                                )}
                            </Box>

                            <Menu
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                            >
                                {sectionOptions.sort().map((section) => (
                                    <MenuItem
                                        key={section}
                                        selected={section === eventReceipt.section}
                                        onClick={() => handleSelect(section)}
                                    >
                                        {section}
                                    </MenuItem>
                                ))}
                            </Menu>

                            {/* Right Column: Total Amount & Authorized Business Cost Subtext */}
                            <Box display="flex" flexDirection="column" alignItems="flex-end">
                                <Typography variant="subtitle1" sx={{ color: '#006064', fontWeight: 700, lineHeight: 1.2 }}>
                                    {new Intl.NumberFormat(undefined, {
                                        style: 'currency',
                                        currency: eventReceipt.currency || 'USD',
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    }).format(parseFloat(eventReceipt.amount) || 0)}
                                </Typography>

                                {/* Authorized Business Amount (Only displays if it's marked as business and has an approved value) */}
                                {eventReceipt.is_business_expense && (parseFloat(eventReceipt.business_expense_amount_authorized) > 0 || parseFloat(eventReceipt.business_expense_amount) > 0) && (
                                    <Typography
                                        variant="caption"
                                        sx={{
                                            color: '#2e7d32',
                                            fontWeight: 600,
                                            fontSize: '11px',
                                            mt: 0.5
                                        }}
                                    >
                                        Auth: {new Intl.NumberFormat(undefined, {
                                        style: 'currency',
                                        currency: eventReceipt.currency || 'USD'
                                    }).format(parseFloat(eventReceipt.business_expense_amount_authorized || eventReceipt.business_expense_amount))}
                                    </Typography>
                                )}
                            </Box>
                        </Box>
                    </Box>

                    {/* Service Date Entry Label */}
                    {receiptServiceDate !== '' && (
                        <Box sx={{ textAlign: 'right', padding: '4px 16px 0 0' }}>
                            <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 500 }}>
                                📅 Service Date: {dayjs(receiptServiceDate).format('ddd, MMM D, YYYY')}
                            </Typography>
                        </Box>
                    )}

                    {/* DYNAMIC METADATA CONTROLLER (Renders ONLY if data exists to show) */}
                    {((eventReceipt.section === "Flights" && eventReceipt.section_item) || (eventReceipt.location && eventReceipt.location.name?.trim())) && (
                        <Box sx={{ padding: '0 16px 16px 16px', mt: 2 }}>
                            {(() => {
                                // State 1: Linked Flight Metadata Details
                                if (eventReceipt.section === "Flights" && eventReceipt.section_item) {
                                    const linkedFlight = eventFlights?.find(f => f.id === eventReceipt.section_item);
                                    if (!linkedFlight) return null;

                                    const resolvedPassenger = (() => {
                                        const targetId = linkedFlight.attendee?.id || linkedFlight.attendee_id;
                                        if (!targetId) return null;
                                        const refMatch = attendeesReferenceArray?.find(user => String(user.id) === String(targetId));
                                        if (!refMatch) return linkedFlight.attendee?.name || "Passenger Context Loaded";
                                        return refMatch.nickname?.trim() || `${refMatch.fname || ''} ${refMatch.lname || ''}`.trim() || refMatch.name;
                                    })();

                                    return (
                                        <Box
                                            sx={{
                                                p: 1.5,
                                                borderRadius: '10px',
                                                backgroundColor: 'rgba(16, 49, 143, 0.03)',
                                                border: '1px solid rgba(16, 49, 143, 0.08)'
                                            }}
                                        >
                                            <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                                                <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#10318f' }}>
                                                    ✈️ {linkedFlight.airline_name || linkedFlight.airline_code || 'Flight'} {linkedFlight.flight_number || ''}
                                                </Typography>
                                                {resolvedPassenger && (
                                                    <Box sx={{ backgroundColor: '#10318f', px: 1, py: 0.2, borderRadius: '4px' }}>
                                                        <Typography sx={{ fontSize: '10px', color: '#fff', fontWeight: 700 }}>
                                                            👤 {resolvedPassenger}
                                                        </Typography>
                                                    </Box>
                                                )}
                                            </Box>

                                            <Box display="flex" alignItems="center" gap={1} mb={0.5}>
                                                <Typography sx={{ fontSize: '15px', fontWeight: 800 }}>
                                                    {linkedFlight.depart_airport_code || linkedFlight.origin || '???'}
                                                </Typography>
                                                <Typography sx={{ fontSize: '12px', color: 'text.disabled' }}>➔</Typography>
                                                <Typography sx={{ fontSize: '15px', fontWeight: 800 }}>
                                                    {linkedFlight.arrive_airport_code || linkedFlight.destination || '???'}
                                                </Typography>
                                                <Typography sx={{ fontSize: '12px', color: 'text.secondary', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                    ({linkedFlight.arrive_airport_city || ''})
                                                </Typography>
                                            </Box>

                                            {linkedFlight.depart_timestamp && (
                                                <Typography sx={{ fontSize: '11px', color: 'text.secondary', fontWeight: 500, display: 'block' }}>
                                                    🛫 Depart: {dayjs(linkedFlight.depart_timestamp).format('MMM DD, YYYY [at] h:mm A')}
                                                </Typography>
                                            )}
                                        </Box>
                                    );
                                }

                                // State 2: Merchant Location Details Block
                                if (eventReceipt.location && eventReceipt.location.name?.trim()) {
                                    return (
                                        <Box
                                            sx={{
                                                p: 1.5,
                                                borderRadius: '10px',
                                                backgroundColor: 'rgba(0, 0, 0, 0.02)',
                                                border: '1px solid rgba(0, 0, 0, 0.04)'
                                            }}
                                        >
                                            <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.5 }}>
                                                📍 {eventReceipt.location.name}
                                            </Typography>
                                            {eventReceipt.location.address && (
                                                <Typography variant="caption" color="textSecondary" sx={{ display: 'block' }}>
                                                    {eventReceipt.location.address}
                                                </Typography>
                                            )}
                                            {(eventReceipt.location.city || eventReceipt.location.state || eventReceipt.location.zip) && (
                                                <Typography variant="caption" color="textSecondary" sx={{ display: 'block' }}>
                                                    {eventReceipt.location.city || ''} {eventReceipt.location.state || ''} {eventReceipt.location.zip || ''}
                                                </Typography>
                                            )}
                                            {eventReceipt.location.country && (
                                                <Typography variant="caption" color="textSecondary" sx={{ display: 'block' }}>
                                                    {eventReceipt.location.country}
                                                </Typography>
                                            )}
                                            {eventReceipt.location.phone && (
                                                <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 0.5, fontWeight: 500 }}>
                                                    📞 {eventReceipt.location.phone_prefix || ''} {eventReceipt.location.phone}
                                                </Typography>
                                            )}
                                        </Box>
                                    );
                                }

                                return null;
                            })()}
                        </Box>
                    )}

                    {/* MEMO NOTES SYSTEM */}
                    {notes.length > 0 && (
                        <Box
                            sx={{
                                backgroundColor: '#fcf9dd',
                                borderRadius: '8px',
                                padding: '8px 12px',
                                margin: '16px 16px 0 16px',
                                borderLeft: '4px solid #fbc02d'
                            }}
                        >
                            <Typography variant="caption" sx={{ display: "block", color: '#5d4037', fontSize: '12px' }}>
                                <strong>Notes:</strong> {notes}
                            </Typography>
                        </Box>
                    )}

                    {/* Private/Public Switch Visibility Layer */}
                    <Box
                        sx={{
                            position: 'absolute',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            padding: '0 16px 16px 16px',
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                        }}
                    >
                        <FormControlLabel
                            control={
                                <Switch
                                    size="small"
                                    checked={eventReceipt.private}
                                    onChange={() =>
                                        setEventReceipt(prev => ({
                                            ...prev,
                                            private: !prev.private
                                        }))
                                    }
                                />
                            }
                            label="Private"
                            sx={{ '.MuiFormControlLabel-label': { fontSize: '12px', fontWeight: 600 } }}
                        />
                    </Box>
                </Box>

            </Box>

            {/*  this is the area below for all editing  */}
            <CardContent
                sx={{
                    display:receiptTabSelected?'block':'none',
                }}
            >
                {
                    selectedAction === "Location" ? (
                        <div className="lodging-suggestions-add-list-item-footer-location-holder">
                            <Grid container spacing={2} direction="column" sx={{marginTop: '0'}}>
                                <TabContext sx={{position: 'relative'}} value={tabValueLocation}>
                                    <TabList
                                        sx={{
                                            borderBottom: 1,
                                            borderColor: 'divider',
                                            backgroundColor: 'rgba(251, 251, 251, 0.8)',
                                            backdropFilter: 'blur(6px)',
                                        }}
                                        centered
                                        variant="fullWidth"
                                        onChange={handleTabLocationChange}
                                        aria-label="Receipt Location"
                                    >
                                        <Tab
                                            label="Search"
                                            value="search"
                                        />
                                        <Tab
                                            label="Locations"
                                            value="locations"
                                        />
                                        <Tab
                                            label="Address"
                                            value="address"
                                        />
                                    </TabList>

                                    <TabPanel value="search" sx={{padding: '24px 0'}}>

                                        {/* Input box for autocomplete */}
                                        <Box
                                            ref={locationRef}
                                            sx={{
                                                flex: 1,
                                                minHeight: '40px',
                                                width: '100%',
                                                '& gmp-place-autocomplete': {
                                                    width: '100%',
                                                    display: 'block',
                                                    colorScheme: 'light !important',
                                                    backgroundColor: '#ffffff !important',
                                                    borderRadius: '12px !important',
                                                }
                                            }}
                                        />
                                    </TabPanel>
                                    <TabPanel value="locations" sx={{padding: '24px 0'}}>
                                        <Box style={{flex: '1'}}>
                                            <List dense>
                                                {uniqueLocations.length > 0 ? (
                                                    uniqueLocations.map((location, index) => (
                                                        <ListItem key={index} sx={{alignItems: "flex-start"}}
                                                                  button>
                                                            <Checkbox
                                                                checked={receiptLocation?.google_place_id === location.google_place_id}
                                                                onChange={() => handleLocationSelect(location)}
                                                                sx={{padding: "0 8px"}}
                                                            />
                                                            <ListItemText
                                                                primary={location.name || "Unnamed Location"}
                                                                secondary={location.address || "No Address Available"}
                                                            />
                                                        </ListItem>
                                                    ))
                                                ) : (
                                                    <Typography variant="body2"
                                                                sx={{textAlign: "center", color: "gray"}}>
                                                        No Event locations to choose from yet
                                                    </Typography>
                                                )}
                                            </List>

                                        </Box>
                                    </TabPanel>
                                    <TabPanel value="address" sx={{padding: '24px 0'}}>
                                        <Box sx={{display: 'flex', flexDirection: 'column', gap: 2, width: '100%'}}>

                                            {/* Location Name */}
                                            <TextField
                                                label="Name"
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                                value={eventReceipt.location.name}
                                                onChange={handleLocationFieldChange("name")}
                                            />

                                            {/* Address */}
                                            <TextField
                                                label="Address"
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                                value={receiptLocation.address}
                                                onChange={handleLocationFieldChange("address")}
                                            />

                                            {/* City */}
                                            <TextField
                                                label="City"
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                                value={receiptLocation.city}
                                                onChange={handleLocationFieldChange("city")}
                                            />

                                            {/* State */}
                                            <TextField
                                                label="State"
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                                value={receiptLocation.state}
                                                onChange={handleLocationFieldChange("state")}
                                            />

                                            {/* Zip Code */}
                                            <TextField
                                                label="Zip Code"
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                                value={receiptLocation.zip}
                                                onChange={handleLocationFieldChange("zip")}
                                            />

                                            {/* Country */}
                                            <TextField
                                                label="Country"
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                                value={receiptLocation.country}
                                                onChange={handleLocationFieldChange("country")}
                                            />

                                        </Box>
                                    </TabPanel>

                                </TabContext>
                            </Grid>
                        </div>
                    ) : null
                }
                {
                    selectedAction === "Link" ? (
                        <Box sx={{ marginTop: "10px", display: "flex", flexDirection: "column", padding: '0 10px', gap: 2.5 }}>

                            {/* 1. LODGING CATEGORY */}
                            <Box>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            size="small"
                                            checked={eventReceipt.section === "Lodging" && eventReceipt.section_item === ""}
                                            onChange={() => handleReceiptLinkChange(-1, "Lodging")}
                                        />
                                    }
                                    componentsProps={{ typography: { fontSize: '14px', fontWeight: 700, color: '#10318f' } }}
                                    label="General Lodging Pool"
                                />
                                <FormGroup sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 0.5 }}>
                                    {eventLodging.slice().map((lodging) => {
                                        const matchingAttendee = lodging.attendees?.find(
                                            (att) => att.id === eventReceipt.attendee_id
                                        );
                                        const amount = matchingAttendee?.cost ?? lodging.amount_total;
                                        const isSelected = eventReceipt.section === "Lodging" && eventReceipt.section_item === lodging.id;

                                        return (
                                            <Box
                                                key={lodging.id}
                                                onClick={() => handleReceiptLinkChange(lodging.id, "Lodging")}
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    width: "100%",
                                                    p: 1.5,
                                                    borderRadius: '10px',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s ease-in-out',
                                                    backgroundColor: isSelected ? 'rgba(16, 49, 143, 0.05)' : 'rgba(0, 0, 0, 0.02)',
                                                    border: isSelected ? '1px solid rgba(16, 49, 143, 0.25)' : '1px solid rgba(0, 0, 0, 0.05)',
                                                    '&:hover': {
                                                        backgroundColor: isSelected ? 'rgba(16, 49, 143, 0.08)' : 'rgba(0, 0, 0, 0.04)',
                                                        borderColor: isSelected ? 'rgba(16, 49, 143, 0.35)' : 'rgba(0, 0, 0, 0.15)'
                                                    }
                                                }}
                                            >
                                                <Checkbox
                                                    size="small"
                                                    checked={isSelected}
                                                    onChange={() => handleReceiptLinkChange(lodging.id, "Lodging")}
                                                    sx={{ flexShrink: 0, p: 0, mr: 1.5 }}
                                                    onClick={(e) => e.stopPropagation()}
                                                />
                                                <Box sx={{ flex: 1, minWidth: 0 }}>
                                                    <Typography sx={{ fontSize: '14px', fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                        🏨 {lodging.location?.name || lodging.room_details || "Unnamed Lodging"}
                                                    </Typography>
                                                    {lodging.room_details && lodging.location?.name && (
                                                        <Typography sx={{ fontSize: '12px', color: 'text.secondary', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', mt: 0.25 }}>
                                                            {lodging.room_details}
                                                        </Typography>
                                                    )}
                                                </Box>
                                                <Typography sx={{ fontSize: '14px', fontWeight: 700, pl: 1, flexShrink: 0 }}>
                                                    {amount != null ? new Intl.NumberFormat(undefined, { style: 'currency', currency: lodging.currency || 'USD' }).format(parseFloat(amount) || 0) : '$0.00'}
                                                </Typography>
                                            </Box>
                                        );
                                    })}
                                </FormGroup>
                            </Box>

                            {/* 2. MEALS CATEGORY */}
                            <Box>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            size="small"
                                            checked={eventReceipt.section === "Meals" && eventReceipt.section_item === ""}
                                            onChange={() => handleReceiptLinkChange(-1, "Meals")}
                                        />
                                    }
                                    componentsProps={{ typography: { fontSize: '14px', fontWeight: 700, color: '#10318f' } }}
                                    label="General Meals Pool"
                                />
                                <FormGroup sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 0.5 }}>
                                    {eventMeals
                                        .slice()
                                        .sort((a, b) => (a.title || a.name || '').localeCompare(b.title || b.name || ''))
                                        .map((meal) => {
                                            const matchingAttendee = meal.attendees?.find(
                                                (att) => att.id === eventReceipt.attendee_id
                                            );
                                            const amount = matchingAttendee?.cost ?? meal.amount_total;
                                            const isSelected = eventReceipt.section === "Meals" && eventReceipt.section_item === meal.id;

                                            return (
                                                <Box
                                                    key={meal.id}
                                                    onClick={() => handleReceiptLinkChange(meal.id, "Meals")}
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        width: "100%",
                                                        p: 1.5,
                                                        borderRadius: '10px',
                                                        cursor: 'pointer',
                                                        transition: 'all 0.2s ease-in-out',
                                                        backgroundColor: isSelected ? 'rgba(16, 49, 143, 0.05)' : 'rgba(0, 0, 0, 0.02)',
                                                        border: isSelected ? '1px solid rgba(16, 49, 143, 0.25)' : '1px solid rgba(0, 0, 0, 0.05)',
                                                        '&:hover': {
                                                            backgroundColor: isSelected ? 'rgba(16, 49, 143, 0.08)' : 'rgba(0, 0, 0, 0.04)',
                                                            borderColor: isSelected ? 'rgba(16, 49, 143, 0.35)' : 'rgba(0, 0, 0, 0.15)'
                                                        }
                                                    }}
                                                >
                                                    <Checkbox
                                                        size="small"
                                                        checked={isSelected}
                                                        onChange={() => handleReceiptLinkChange(meal.id, "Meals")}
                                                        sx={{ flexShrink: 0, p: 0, mr: 1.5 }}
                                                        onClick={(e) => e.stopPropagation()}
                                                    />
                                                    <Box sx={{ flex: 1, minWidth: 0 }}>
                                                        <Typography sx={{ fontSize: '14px', fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                            🍔 {meal.title || meal.name || meal.location?.name || "Scheduled Meal"}
                                                        </Typography>
                                                        {(meal.location?.name || meal.eat_in_details) && (
                                                            <Typography sx={{ fontSize: '12px', color: 'text.secondary', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', mt: 0.25 }}>
                                                                {meal.location?.name || meal.eat_in_details}
                                                            </Typography>
                                                        )}
                                                    </Box>
                                                    <Typography sx={{ fontSize: '14px', fontWeight: 700, pl: 1, flexShrink: 0 }}>
                                                        {amount != null ? new Intl.NumberFormat(undefined, { style: 'currency', currency: meal.currency || 'USD' }).format(parseFloat(amount) || 0) : '$0.00'}
                                                    </Typography>
                                                </Box>
                                            );
                                        })}
                                </FormGroup>
                            </Box>

                            {/* 3. ACTIVITIES CATEGORY */}
                            <Box>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            size="small"
                                            checked={eventReceipt.section === "Activities" && eventReceipt.section_item === ""}
                                            onChange={() => handleReceiptLinkChange(-1, "Activities")}
                                        />
                                    }
                                    componentsProps={{ typography: { fontSize: '14px', fontWeight: 700, color: '#10318f' } }}
                                    label="General Activities Pool"
                                />
                                <FormGroup sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 0.5 }}>
                                    {eventActivities
                                        .slice()
                                        .sort((a, b) => (a.title || '').localeCompare(b.title || ''))
                                        .map((activity) => {
                                            const matchingAttendee = activity.attendees?.find(
                                                (att) => att.id === eventReceipt.attendee_id
                                            );
                                            const amount = matchingAttendee?.cost ?? activity.amount_total;
                                            const isSelected = eventReceipt.section === "Activities" && eventReceipt.section_item === activity.id;

                                            return (
                                                <Box
                                                    key={activity.id}
                                                    onClick={() => handleReceiptLinkChange(activity.id, "Activities")}
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        width: "100%",
                                                        p: 1.5,
                                                        borderRadius: '10px',
                                                        cursor: 'pointer',
                                                        transition: 'all 0.2s ease-in-out',
                                                        backgroundColor: isSelected ? 'rgba(16, 49, 143, 0.05)' : 'rgba(0, 0, 0, 0.02)',
                                                        border: isSelected ? '1px solid rgba(16, 49, 143, 0.25)' : '1px solid rgba(0, 0, 0, 0.05)',
                                                        '&:hover': {
                                                            backgroundColor: isSelected ? 'rgba(16, 49, 143, 0.08)' : 'rgba(0, 0, 0, 0.04)',
                                                            borderColor: isSelected ? 'rgba(16, 49, 143, 0.35)' : 'rgba(0, 0, 0, 0.15)'
                                                        }
                                                    }}
                                                >
                                                    <Checkbox
                                                        size="small"
                                                        checked={isSelected}
                                                        onChange={() => handleReceiptLinkChange(activity.id, "Activities")}
                                                        sx={{ flexShrink: 0, p: 0, mr: 1.5 }}
                                                        onClick={(e) => e.stopPropagation()}
                                                    />
                                                    <Box sx={{ flex: 1, minWidth: 0 }}>
                                                        <Typography sx={{ fontSize: '14px', fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                            🎯 {activity.title || "Scheduled Activity"}
                                                        </Typography>
                                                    </Box>
                                                    <Typography sx={{ fontSize: '14px', fontWeight: 700, pl: 1, flexShrink: 0 }}>
                                                        {amount != null ? new Intl.NumberFormat(undefined, { style: 'currency', currency: activity.currency || 'USD' }).format(parseFloat(amount) || 0) : '$0.00'}
                                                    </Typography>
                                                </Box>
                                            );
                                        })}
                                </FormGroup>
                            </Box>

                            {/* 4. FLIGHTS CATEGORY */}
                            <Box>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            size="small"
                                            checked={eventReceipt.section === "Flights" && eventReceipt.section_item === ""}
                                            onChange={() => handleReceiptLinkChange(-1, "Flights")}
                                        />
                                    }
                                    componentsProps={{ typography: { fontSize: '14px', fontWeight: 700, color: '#10318f' } }}
                                    label="General Flights Pool"
                                />
                                <FormGroup sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 0.5 }}>
                                    {eventFlights
                                        .slice()
                                        .sort((a, b) => dayjs(a.depart_timestamp).unix() - dayjs(b.depart_timestamp).unix())
                                        .map((flight) => {
                                            const matchingAttendee = flight.attendees?.find(
                                                (att) => att.id === eventReceipt.attendee_id
                                            );
                                            const amount = matchingAttendee?.cost ?? flight.amount_total ?? flight.cost;
                                            const isSelected = eventReceipt.section === "Flights" && eventReceipt.section_item === flight.id;

                                            const resolvedPassengerName = (() => {
                                                const targetId = flight.attendee?.id || flight.attendee_id;
                                                if (!targetId) return "Unknown Passenger";
                                                const refMatch = attendeesReferenceArray?.find((user) => String(user.id) === String(targetId));
                                                if (!refMatch) return flight.attendee?.name || "Passenger ID: " + targetId.substring(0, 5);
                                                if (refMatch.nickname?.trim()) return refMatch.nickname.trim();
                                                if (refMatch.fname?.trim() || refMatch.lname?.trim()) return `${refMatch.fname || ''} ${refMatch.lname || ''}`.trim();
                                                return refMatch.name || "Passenger";
                                            })();

                                            return (
                                                <Box
                                                    key={flight.id}
                                                    onClick={() => handleReceiptLinkChange(flight.id, "Flights")}
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        width: "100%",
                                                        p: 1.5,
                                                        borderRadius: '10px',
                                                        cursor: 'pointer',
                                                        transition: 'all 0.2s ease-in-out',
                                                        backgroundColor: isSelected ? 'rgba(16, 49, 143, 0.05)' : 'rgba(0, 0, 0, 0.02)',
                                                        border: isSelected ? '1px solid rgba(16, 49, 143, 0.25)' : '1px solid rgba(0, 0, 0, 0.05)',
                                                        '&:hover': {
                                                            backgroundColor: isSelected ? 'rgba(16, 49, 143, 0.08)' : 'rgba(0, 0, 0, 0.04)',
                                                            borderColor: isSelected ? 'rgba(16, 49, 143, 0.35)' : 'rgba(0, 0, 0, 0.15)'
                                                        }
                                                    }}
                                                >
                                                    <Checkbox
                                                        size="small"
                                                        checked={isSelected}
                                                        onChange={() => handleReceiptLinkChange(flight.id, "Flights")}
                                                        sx={{ flexShrink: 0, p: 0, mr: 1.5 }}
                                                        onClick={(e) => e.stopPropagation()}
                                                    />
                                                    <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                                        <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
                                                            <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#10318f' }}>
                                                                {flight.airline_name || flight.airline_code || 'Flight'} {flight.flight_number || ''}
                                                            </Typography>
                                                            <Box sx={{ backgroundColor: 'rgba(16, 49, 143, 0.08)', px: 1, py: 0.2, borderRadius: '4px', border: '1px solid rgba(16, 49, 143, 0.12)' }}>
                                                                <Typography sx={{ fontSize: '11px', color: '#10318f', fontWeight: 700 }}>
                                                                    👤 {resolvedPassengerName}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                        <Box display="flex" alignItems="center" gap={0.75}>
                                                            <Typography sx={{ fontSize: '14px', fontWeight: 800 }}>{flight.depart_airport_code || flight.origin || '???'}</Typography>
                                                            <Typography sx={{ fontSize: '12px', color: 'text.disabled' }}>➔</Typography>
                                                            <Typography sx={{ fontSize: '14px', fontWeight: 800 }}>{flight.arrive_airport_code || flight.destination || '???'}</Typography>
                                                            <Typography sx={{ fontSize: '12px', color: 'text.secondary', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', ml: 0.5 }}>({flight.arrive_airport_city || ''})</Typography>
                                                        </Box>
                                                        {flight.depart_timestamp && (
                                                            <Typography sx={{ fontSize: '11.5px', color: 'text.secondary', fontWeight: 500 }}>
                                                                📅 {dayjs(flight.depart_timestamp).format('MMM DD, YYYY')} • 🕒 {dayjs(flight.depart_timestamp).format('h:mm A')}
                                                            </Typography>
                                                        )}
                                                    </Box>
                                                    <Typography sx={{ fontSize: '14px', fontWeight: 700, pl: 1, flexShrink: 0 }}>
                                                        {amount != null && parseFloat(amount) > 0 ? new Intl.NumberFormat(undefined, { style: 'currency', currency: flight.currency || 'USD' }).format(parseFloat(amount)) : '$0.00'}
                                                    </Typography>
                                                </Box>
                                            );
                                        })}
                                </FormGroup>
                            </Box>

                            {/* 5. QUICK STANDALONE CATEGORIES (Organized Modern Grid Layout) */}
                            <Box sx={{ mt: 1, pt: 2, borderTop: '1px dashed rgba(0,0,0,0.1)' }}>
                                <Typography variant="caption" sx={{ display: 'block', mb: 1.5, fontWeight: 700, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                    Quick Categories
                                </Typography>
                                <Box
                                    sx={{
                                        display: 'grid',
                                        gridTemplateColumns: { xs: '1fr 1fr', sm: '1fr 1fr 1fr' },
                                        gap: 1.5
                                    }}
                                >
                                    {[
                                        { id: "Supplies", icon: "📦" },
                                        { id: "Incidentals", icon: "🎟️" },
                                        { id: "Shopping", icon: "🛍️" },
                                        { id: "Transportation", icon: "🚗" },
                                        { id: "General", icon: "✨" }
                                    ].map((cat) => {
                                        const isCatSelected = eventReceipt.section === cat.id && eventReceipt.section_item === "";
                                        return (
                                            <Box
                                                key={cat.id}
                                                onClick={() => handleReceiptLinkChange(-1, cat.id)}
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 1,
                                                    p: 1.25,
                                                    borderRadius: '8px',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.15s ease-in-out',
                                                    backgroundColor: isCatSelected ? 'rgba(16, 49, 143, 0.06)' : 'rgba(0,0,0,0.02)',
                                                    border: isCatSelected ? '1px solid #10318f' : '1px solid rgba(0,0,0,0.06)',
                                                    '&:hover': {
                                                        backgroundColor: isCatSelected ? 'rgba(16, 49, 143, 0.09)' : 'rgba(0,0,0,0.05)',
                                                        borderColor: isCatSelected ? '#10318f' : 'rgba(0,0,0,0.2)'
                                                    }
                                                }}
                                            >
                                                <Checkbox
                                                    size="small"
                                                    checked={isCatSelected}
                                                    onChange={() => handleReceiptLinkChange(-1, cat.id)}
                                                    sx={{ p: 0 }}
                                                    onClick={(e) => e.stopPropagation()}
                                                />
                                                <Typography sx={{ fontSize: '13px', fontWeight: 600, color: isCatSelected ? '#10318f' : 'text.primary', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                    {cat.icon} {cat.id}
                                                </Typography>
                                            </Box>
                                        );
                                    })}
                                </Box>
                            </Box>

                        </Box>
                    ) : null
                }
                {
                    selectedAction === "Amount" ? (
                        <Box sx={{ display: "flex", flexDirection: "column", width: "100%", gap: 1 }}>
                            {/* Line 1: Amount & Currency */}
                            <Box sx={{ display: "flex", alignItems: "center", width: "100%", mb:1 }}>
                                <TextField
                                    fullWidth
                                    label="Amount"
                                    name="amount"
                                    type="text"
                                    value={eventReceipt.amount}
                                    onChange={(e) =>
                                        setEventReceipt((prev) => ({
                                            ...prev,
                                            amount: e.target.value
                                        }))}
                                    variant="standard"
                                    sx={{ flex: 1 }}
                                />
                                <IconButton
                                    sx={{ fontSize: '12px', color: 'initial', ml: 1 }}
                                    aria-label="change-currency"
                                    onClick={(e) => setAnchorChangeCurrencyEl(e.currentTarget)}
                                >
                                    {eventReceipt.currency}
                                </IconButton>
                                <Menu
                                    anchorEl={anchorChangeCurrencyEl}
                                    open={Boolean(anchorChangeCurrencyEl)}
                                    onClose={() => setAnchorChangeCurrencyEl(null)}
                                >
                                    {currencyList.map((option) => (
                                        <MenuItem
                                            key={option.code}
                                            selected={option.code === eventReceipt.currency}
                                            onClick={(e) => {
                                                handleChangeCurrencyClick(e, option.code);
                                                setAnchorChangeCurrencyEl(null);
                                            }}
                                        >
                                            {option.code} : {option.name}
                                        </MenuItem>
                                    ))}
                                </Menu>
                            </Box>

                            {/* Line 2: Date of Service */}
                            <Box sx={{ display: "flex", alignItems: "center", width: "100%" , mb:1}}>
                                <DatePicker
                                    sx={{ width: '100%' }}
                                    label="Date of Service"
                                    value={dayjs(receiptServiceDate, 'YYYY-MM-DD')}
                                    onChange={(e)=> setReceiptServiceDate(e.format('YYYY-MM-DD'))}
                                />
                            </Box>

                            {/* Line 3: Business Expense */}
                            <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            size="small"
                                            checked={eventReceipt.is_business_expense}
                                            onChange={() =>
                                                setEventReceipt(prev => {
                                                    const nextState = !prev.is_business_expense;
                                                    return {
                                                        ...prev,
                                                        is_business_expense: nextState,
                                                        business_expense_amount: nextState ? prev.amount : 0
                                                    };
                                                })
                                            }
                                        />
                                    }
                                    label="Business"
                                    sx={{ '.MuiFormControlLabel-label': { fontSize: '12px' } }}
                                />

                                <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 1 }}>
                                    {editModeBusinessExpense ? (
                                        <TextField
                                            label="Amount"
                                            value={eventReceipt.business_expense_amount}
                                            onChange={(e) => {
                                                const inputValue = e.target.value;
                                                if (/^[0-9.,]*$/.test(inputValue)) {
                                                    const formattedValue = inputValue.replace(/,/g, "");
                                                    setEventReceipt(prev => ({
                                                        ...prev,
                                                        business_expense_amount: formattedValue
                                                    }));
                                                }
                                            }}
                                            variant="standard"
                                            sx={{ minWidth: '80px', maxWidth: '100px', textAlign: 'right' }}
                                        />
                                    ) : (
                                        <Typography sx={{fontSize:'14px', fontWeight: 600}}>
                                            {parseFloat(eventReceipt.business_expense_amount || 0).toFixed(2)}&nbsp;{eventReceipt.currency}
                                        </Typography>
                                    )}
                                    <i
                                        className={editModeBusinessExpense ? 'icon-check' : 'icon-pencil'}
                                        style={{ cursor: 'pointer', fontSize: editModeBusinessExpense ? '14px' : '12px' }}
                                        onClick={() => setEditModeBusinessExpense(!editModeBusinessExpense)}
                                    />
                                </Box>
                            </Box>

                            {/* 💼 LINE 4: FIXED REFRESH-BASED CASCADE DEDUCTION ENGINE */}
                            {eventReceipt.is_business_expense && (() => {
                                const businessAuth = PA_GlobalObject?.Planning?.business_authorizations || {};
                                const currentCategory = (eventReceipt.section || 'General').toLowerCase();
                                const attendeeId = eventReceipt.attendee_id;
                                const currentReceiptDate = receiptServiceDate || dayjs().format('YYYY-MM-DD');
                                const currentInputAmt = parseFloat(eventReceipt.business_expense_amount || 0);

                                // 1. Resolve Auth Configuration Values
                                const eventLimit = parseFloat(businessAuth.eventTotalLimit) || 0;
                                const dailyLimit = parseFloat(businessAuth.dailyLimit) || 0;
                                const isCustomMode = businessAuth.categoryMode === "custom";

                                const categoryLimit = businessAuth.categoryLimits?.[currentCategory] !== undefined && businessAuth.categoryLimits?.[currentCategory] !== null
                                    ? parseFloat(businessAuth.categoryLimits[currentCategory]) : null;
                                const categoryUnit = businessAuth.categoryUnits?.[currentCategory] || "For Entire Event";

                                const individualLimitObj = businessAuth.individualLimits?.[attendeeId] || {};
                                const individualLimit = individualLimitObj[currentCategory] !== undefined && individualLimitObj[currentCategory] !== null
                                    ? parseFloat(individualLimitObj[currentCategory]) : null;
                                const individualUnit = individualLimitObj[`${currentCategory}_unit`] || "Each Night";

                                const activeCategoryLimit = isCustomMode ? individualLimit : categoryLimit;
                                const activeUnit = (isCustomMode ? individualUnit : categoryUnit).toLowerCase();

                                // Flags to dictate scoping behavior
                                const isItemizedScope = activeUnit.includes("meal") || activeUnit.includes("receipt") || activeUnit.includes("activity") || activeUnit.includes("direction");
                                const isDailyScope = activeUnit.includes("day") || activeUnit.includes("night");

                                // 2. Aggregate Existing PRIOR expenses (Safely excluding the active card)
                                let previouslySpentOnSameDayDailyLimitPool = 0;
                                let previouslySpentCategoryAccumulator = 0;
                                let previouslySpentTotalEventPool = 0;

                                const coreCategories = ['lodging', 'meals', 'activities', 'flights', 'supplies', 'incidentals', 'shopping', 'transportation'];

                                coreCategories.forEach((catKey) => {
                                    const items = PA_GlobalObject.Planning?.[catKey] || [];
                                    items.forEach((item) => {
                                        if (item.id === eventReceipt.id) return; // Skip active card configuration

                                        let expAmt = 0;
                                        let itemDates = [];

                                        if (Array.isArray(item.attendees)) {
                                            const attMatch = item.attendees.find(a => a.id === attendeeId && a.is_business_expense);
                                            if (attMatch) expAmt = parseFloat(attMatch.business_expense_amount) || 0;
                                        } else if (item.attendee_id === attendeeId && item.is_business_expense) {
                                            expAmt = parseFloat(item.business_expense_amount) || 0;
                                        }

                                        if (expAmt <= 0) return;

                                        if (item.time_table?.dates?.length > 0) {
                                            itemDates = item.time_table.dates.map(d => d.date);
                                        } else {
                                            itemDates = [item.date || currentReceiptDate];
                                        }

                                        const numDays = itemDates.length || 1;
                                        const itemPerDayCost = expAmt / numDays;

                                        itemDates.forEach((dKey) => {
                                            previouslySpentTotalEventPool += itemPerDayCost;

                                            if (catKey === currentCategory) {
                                                if (isDailyScope && dKey === currentReceiptDate) {
                                                    previouslySpentCategoryAccumulator += itemPerDayCost;
                                                } else if (!isDailyScope && !isItemizedScope) {
                                                    // For Entire Event scope accumulation
                                                    previouslySpentCategoryAccumulator += itemPerDayCost;
                                                }
                                            }

                                            if (['meals', 'activities', 'incidentals'].includes(catKey) && dKey === currentReceiptDate) {
                                                previouslySpentOnSameDayDailyLimitPool += itemPerDayCost;
                                            }
                                        });
                                    });
                                });

                                // Check flat receipts store array
                                (PA_GlobalObject.Planning?.receipts || []).forEach((rec) => {
                                    if (rec.id === eventReceipt.id || rec.attendee_id !== attendeeId || !rec.is_business_expense) return;

                                    const recCat = (rec.section || '').toLowerCase();
                                    const recAmt = parseFloat(rec.business_expense_amount) || 0;
                                    const recDate = rec.date || currentReceiptDate;

                                    previouslySpentTotalEventPool += recAmt;

                                    if (recCat === currentCategory) {
                                        if (isDailyScope && recDate === currentReceiptDate) {
                                            previouslySpentCategoryAccumulator += recAmt;
                                        } else if (!isDailyScope && !isItemizedScope) {
                                            previouslySpentCategoryAccumulator += recAmt;
                                        }
                                    }

                                    if (['meals', 'activities', 'incidentals'].includes(recCat) && recDate === currentReceiptDate) {
                                        previouslySpentOnSameDayDailyLimitPool += recAmt;
                                    }
                                });

                                // 3. Compute Sequential Authorization Breakdown
                                let trackingRemainder = currentInputAmt;
                                let authorizedFromCategory = 0;
                                let authorizedFromDaily = 0;
                                let authorizedFromEvent = 0;

                                // Step A: Evaluate Category rule
                                let categoryDisplaySpent = 0;
                                if (activeCategoryLimit !== null) {
                                    let availableCategoryRoom = 0;

                                    if (isItemizedScope) {
                                        // "Each Meal" / "Each Receipt" resets baseline caps per item!
                                        availableCategoryRoom = activeCategoryLimit;
                                        categoryDisplaySpent = 0;
                                    } else {
                                        // Cumulative scope logic
                                        availableCategoryRoom = Math.max(activeCategoryLimit - previouslySpentCategoryAccumulator, 0);
                                        categoryDisplaySpent = previouslySpentCategoryAccumulator;
                                    }

                                    let maxAllowable = Math.min(trackingRemainder, availableCategoryRoom);
                                    authorizedFromCategory = maxAllowable;
                                    trackingRemainder -= maxAllowable;
                                }

                                // Step B: Evaluate Rolling Daily Caps
                                if (dailyLimit > 0 && ['meals', 'activities', 'incidentals'].includes(currentCategory)) {
                                    // Reduce daily pool based on what prior cards *and* the current card's approved category portion consumed
                                    let remainingDailyRoom = Math.max(dailyLimit - previouslySpentOnSameDayDailyLimitPool - authorizedFromCategory, 0);
                                    let maxAllowable = Math.min(trackingRemainder, remainingDailyRoom);
                                    authorizedFromDaily = maxAllowable;
                                    trackingRemainder -= maxAllowable;
                                }

                                // Step C: Evaluate Event Safety Max Cap Ceiling
                                if (eventLimit > 0) {
                                    let assignedPreConsumption = previouslySpentTotalEventPool + authorizedFromCategory + authorizedFromDaily;
                                    let remainingEventRoom = Math.max(eventLimit - assignedPreConsumption, 0);
                                    let maxAllowable = Math.min(trackingRemainder, remainingEventRoom);
                                    authorizedFromEvent = maxAllowable;
                                    trackingRemainder -= maxAllowable;
                                }

                                const totalCovered = authorizedFromCategory + authorizedFromDaily + authorizedFromEvent;
                                const notCovered = Math.max(currentInputAmt - totalCovered, 0);

                                return (
                                    <Box sx={{ mt: 1.5, pt: 1.5, borderTop: '1px dashed rgba(0,0,0,0.1)' }}>
                                        <Typography variant="caption" sx={{ display: 'block', mb: 1, fontWeight: 700, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                            Structural Limit Matrix Evaluation
                                        </Typography>

                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>

                                            {/* 🏷️ CATEGORY LIMIT DEDUCTION STATUS */}
                                            {activeCategoryLimit !== null && (
                                                <Box sx={{ p: 1, borderRadius: '6px', backgroundColor: 'rgba(0,0,0,0.02)', border: '1px solid rgba(0,0,0,0.04)' }}>
                                                    <Box display="flex" justifyContent="space-between">
                                                        <Typography sx={{ fontSize: '11.5px', fontWeight: 600 }}>
                                                            {isCustomMode ? "👤 Individual Custom Limit" : "🏷️ Category Authorization Limit"}
                                                        </Typography>
                                                        <Typography sx={{ fontSize: '11.5px', fontWeight: 700 }}>
                                                            {activeCategoryLimit.toFixed(2)} {eventReceipt.currency}
                                                        </Typography>
                                                    </Box>
                                                    <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 0.25 }}>
                                                        Scope Scope: {isCustomMode ? individualUnit : categoryUnit}
                                                        {isItemizedScope ? " • Fresh limit per item" : ` • Previously Used: ${categoryDisplaySpent.toFixed(2)} ${eventReceipt.currency}`}
                                                    </Typography>
                                                    <Typography variant="caption" sx={{ fontWeight: 600, color: authorizedFromCategory > 0 ? 'success.main' : 'text.secondary' }}>
                                                        ↳ Covered by this rule: +{authorizedFromCategory.toFixed(2)} {eventReceipt.currency}
                                                    </Typography>
                                                </Box>
                                            )}

                                            {/* 📅 DAILY CEILING LIMIT STATUS */}
                                            {dailyLimit > 0 && ['meals', 'activities', 'incidentals'].includes(currentCategory) && (
                                                <Box sx={{ p: 1, borderRadius: '6px', backgroundColor: 'rgba(0,0,0,0.02)', border: '1px solid rgba(0,0,0,0.04)' }}>
                                                    <Box display="flex" justifyContent="space-between">
                                                        <Typography sx={{ fontSize: '11.5px', fontWeight: 600 }}>📅 Daily Rolling Spending Ceiling</Typography>
                                                        <Typography sx={{ fontSize: '11.5px', fontWeight: 700 }}>{dailyLimit.toFixed(2)} {eventReceipt.currency}</Typography>
                                                    </Box>
                                                    <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 0.25 }}>
                                                        Spent Today (other items): {previouslySpentOnSameDayDailyLimitPool.toFixed(2)} {eventReceipt.currency}
                                                    </Typography>
                                                    <Typography variant="caption" sx={{ fontWeight: 600, color: authorizedFromDaily > 0 ? 'success.main' : 'text.secondary' }}>
                                                        ↳ Covered by this rule: +{authorizedFromDaily.toFixed(2)} {eventReceipt.currency}
                                                    </Typography>
                                                </Box>
                                            )}

                                            {/* 🛡️ EVENT SAFETY NET CEILING STATUS */}
                                            {eventLimit > 0 && (
                                                <Box sx={{ p: 1, borderRadius: '6px', backgroundColor: 'rgba(0,0,0,0.02)', border: '1px solid rgba(0,0,0,0.04)' }}>
                                                    <Box display="flex" justifyContent="space-between">
                                                        <Typography sx={{ fontSize: '11.5px', fontWeight: 600 }}>🛡️ Event Authorization Max Cap</Typography>
                                                        <Typography sx={{ fontSize: '11.5px', fontWeight: 700 }}>{eventLimit.toFixed(2)} {eventReceipt.currency}</Typography>
                                                    </Box>
                                                    <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 0.25 }}>
                                                        Cumulative Event Spend: {previouslySpentTotalEventPool.toFixed(2)} {eventReceipt.currency}
                                                    </Typography>
                                                    <Typography variant="caption" sx={{ fontWeight: 600, color: authorizedFromEvent > 0 ? 'success.main' : 'text.secondary' }}>
                                                        ↳ Covered by this rule: +{authorizedFromEvent.toFixed(2)} {eventReceipt.currency}
                                                    </Typography>
                                                </Box>
                                            )}

                                            {/* 📊 CALCULATED BALANCE CARD */}
                                            <Box sx={{
                                                mt: 0.5, p: 1, borderRadius: '6px',
                                                border: '1px solid',
                                                borderColor: notCovered > 0 ? '#ffe0b2' : '#c8e6c9',
                                                backgroundColor: notCovered > 0 ? '#fff8e1' : '#f1f8e9',
                                                display: 'flex', justifyContent: 'space-between', alignItems: 'center'
                                            }}>
                                                <Box>
                                                    <Typography sx={{ fontSize: '12px', fontWeight: 700, color: notCovered > 0 ? '#e65100' : '#2e7d32' }}>
                                                        {notCovered > 0 ? "⚠️ PARTIALLY COVERED" : "✓ FULLY AUTHORIZED"}
                                                    </Typography>
                                                    <Typography variant="caption" color="textSecondary">
                                                        Total Covered: {totalCovered.toFixed(2)} {eventReceipt.currency}
                                                    </Typography>
                                                </Box>
                                                {notCovered > 0 && (
                                                    <Typography sx={{ fontSize: '12px', fontWeight: 800, color: '#d32f2f' }}>
                                                        +{notCovered.toFixed(2)} Out of Pocket
                                                    </Typography>
                                                )}
                                            </Box>
                                        </Box>
                                    </Box>
                                );
                            })()}
                        </Box>
                    ) : null
                }
                {
                    selectedAction === "Photo" ? (
                        <Card sx={{display: "flex", flexDirection: "column", padding: "10px"}}>
                            <CardContent sx={{display: "flex", flexDirection: "column", gap: 1}}>
                                {/* Dropzone for File Uploads */}
                                <div {...getRootProps()} style={{
                                    border: '2px dashed #e0e4e8',
                                    padding: '20px',
                                    borderRadius: '12px',
                                    textAlign: 'center',
                                    backgroundColor: isDragActive ? '#f0f4f8' : '#fafafa'
                                }}>
                                    <input {...getInputProps()} />
                                    <CloudUploadIcon sx={{color: '#bdc3c7', mb: 1}}/>
                                    <Typography sx={{fontSize: '11px', fontWeight: 700, color: '#151269'}}>
                                        {imageData ? 'Change File' : 'Select Document'}
                                    </Typography>
                                </div>

                                {/* AI Processing Toggle */}
                                <FormControlLabel
                                    control={<Switch checked={useExperimentalAi}
                                                     onChange={() => setUseExperimentalAi(!useExperimentalAi)}/>}
                                    label={
                                        <Typography variant="caption" color="textSecondary">
                                            Use AI
                                        </Typography>
                                    }
                                />

                                {/* AI Helper Text */}
                                <Typography variant="caption" color="textSecondary">
                                    AI will extract receipt data.
                                </Typography>

                                {/*
                                    so in this area we want to show an indicator that AI is processing the receipt
                                    and we want to show the list of JSON key/value pairs that were returned from AI
                                    and we want to have a checkbox next to each key/value pair to use/not use
                                    and we want to have an OK button to actually apply the use/not use items
                                 */}
                                {/* AI Processing Indicator */}
                                {isProcessing && (
                                    <Box sx={{display: "flex", alignItems: "center", gap: 1, mt: 1}}>
                                        <CircularProgress size={20}/>
                                        <Typography variant="caption" color="textSecondary">
                                            AI is analyzing the receipt...
                                        </Typography>
                                    </Box>
                                )}
                                {/* AI Smart Review - Clean Vertical Layout */}
                                {aiResults && Object.keys(aiResults).length > 0 && (
                                    <Box sx={{
                                        mt: 2,
                                        p: 2,
                                        borderRadius: '16px',
                                        background: 'linear-gradient(145deg, #ffffff 0%, #f0f7ff 100%)',
                                        border: '1px solid #cce3ff'
                                    }}>

                                        <Box sx={{display: 'flex', flexDirection: 'column', gap: 3}}>

                                            {/* GROUP: FINANCIALS */}
                                            <Box sx={{
                                                p: 2,
                                                bgcolor: '#fff',
                                                borderRadius: '12px',
                                                border: '1px solid #e1e8ed'
                                            }}>
                                                <Typography variant="caption" sx={{
                                                    fontWeight: 900,
                                                    color: '#1976d2',
                                                    letterSpacing: '1px',
                                                    mb: 2,
                                                    display: 'block'
                                                }}>FINANCIALS</Typography>
                                                <Box sx={{display: 'flex', flexDirection: 'column', gap: 2}}>
                                                    <TextField select label="Category" size="small" fullWidth
                                                               value={(!aiResults.category || aiResults.category === "Not found") ? "General" : aiResults.category}
                                                               onChange={(e) => setAiResults(p => ({
                                                                   ...p,
                                                                   category: e.target.value
                                                               }))}>
                                                        {sectionOptions.map((opt) => <MenuItem key={opt}
                                                                                               value={opt}>{opt}</MenuItem>)}
                                                    </TextField>
                                                    <TextField select label="Currency" size="small" fullWidth
                                                               value={(!aiResults.currency || aiResults.currency === "Not found") ? "USD" : aiResults.currency}
                                                               onChange={(e) => setAiResults(p => ({
                                                                   ...p,
                                                                   currency: e.target.value
                                                               }))}>
                                                        {currencyList.map((c) => <MenuItem key={c.code}
                                                                                           value={c.code}>{c.code} - {c.name}</MenuItem>)}
                                                    </TextField>
                                                    <TextField label="Total Amount" size="small" fullWidth
                                                               value={(aiResults.grandTotal === "Not found") ? "" : aiResults.grandTotal || ""}
                                                               onChange={(e) => setAiResults(p => ({
                                                                   ...p,
                                                                   grandTotal: e.target.value
                                                               }))}/>
                                                    <TextField label="Amount Due / Balance" size="small" fullWidth
                                                               value={(aiResults.amountDue === "Not found") ? "" : aiResults.amountDue || ""}
                                                               onChange={(e) => setAiResults(p => ({
                                                                   ...p,
                                                                   amountDue: e.target.value
                                                               }))}/>
                                                    <TextField
                                                        label="Transaction Date"
                                                        type="date"
                                                        size="small"
                                                        fullWidth
                                                        InputLabelProps={{shrink: true}}
                                                        // Use the helper here to sanitize the format
                                                        value={formatDateForInput(aiResults.receiptDate)}
                                                        onChange={(e) => setAiResults(p => ({
                                                            ...p,
                                                            receiptDate: e.target.value
                                                        }))}
                                                    />
                                                </Box>
                                            </Box>

                                            {/* GROUP: RESERVATION & LINKING */}
                                            <Box sx={{
                                                p: 2,
                                                bgcolor: '#fff',
                                                borderRadius: '12px',
                                                border: '1px solid #e1e8ed'
                                            }}>
                                                <Typography variant="caption" sx={{
                                                    fontWeight: 900,
                                                    color: '#d32f2f',
                                                    letterSpacing: '1px',
                                                    mb: 2,
                                                    display: 'block'
                                                }}>RESERVATION & LINKING</Typography>
                                                <Box sx={{display: 'flex', flexDirection: 'column', gap: 2}}>
                                                    <TextField label="Booked Through" size="small" fullWidth
                                                               value={(aiResults.bookedThrough === "Not found") ? "" : aiResults.bookedThrough || ""}
                                                               onChange={(e) => setAiResults(p => ({
                                                                   ...p,
                                                                   bookedThrough: e.target.value
                                                               }))}/>
                                                    <TextField label="Confirmation Code" size="small" fullWidth
                                                               value={(aiResults.confirmationCode === "Not found") ? "" : aiResults.confirmationCode || ""}
                                                               onChange={(e) => setAiResults(p => ({
                                                                   ...p,
                                                                   confirmationCode: e.target.value
                                                               }))}/>
                                                    <TextField label="Receipt / Invoice ID" size="small" fullWidth
                                                               value={(aiResults.receiptID === "Not found") ? "" : aiResults.receiptID || ""}
                                                               onChange={(e) => setAiResults(p => ({
                                                                   ...p,
                                                                   receiptID: e.target.value
                                                               }))}/>
                                                    <TextField label="Reservation Name" size="small" fullWidth
                                                               value={(aiResults.reservationName === "Not found") ? "" : aiResults.reservationName || ""}
                                                               onChange={(e) => setAiResults(p => ({
                                                                   ...p,
                                                                   reservationName: e.target.value
                                                               }))}/>
                                                    <TextField label="Reservation / Folio Number" size="small" fullWidth
                                                               value={(aiResults.reservationNumber === "Not found") ? "" : aiResults.reservationNumber || ""}
                                                               onChange={(e) => setAiResults(p => ({
                                                                   ...p,
                                                                   reservationNumber: e.target.value
                                                               }))}/>
                                                </Box>
                                            </Box>

                                            {/* GROUP: MERCHANT DETAILS */}
                                            <Box sx={{
                                                p: 2,
                                                bgcolor: '#fff',
                                                borderRadius: '12px',
                                                border: '1px solid #e1e8ed'
                                            }}>
                                                <Typography variant="caption" sx={{
                                                    fontWeight: 900,
                                                    color: '#1976d2',
                                                    letterSpacing: '1px',
                                                    mb: 2,
                                                    display: 'block'
                                                }}>MERCHANT DETAILS</Typography>
                                                <Box sx={{display: 'flex', flexDirection: 'column', gap: 2}}>
                                                    <TextField label="Business Name" size="small" fullWidth
                                                               value={(aiResults.businessName === "Not found") ? "" : aiResults.businessName || ""}
                                                               onChange={(e) => setAiResults(p => ({
                                                                   ...p,
                                                                   businessName: e.target.value
                                                               }))}/>
                                                    <TextField label="Street Address" size="small" fullWidth
                                                               value={(aiResults.businessAddress === "Not found") ? "" : aiResults.businessAddress || ""}
                                                               onChange={(e) => setAiResults(p => ({
                                                                   ...p,
                                                                   businessAddress: e.target.value
                                                               }))}/>
                                                    <TextField label="City" size="small" fullWidth
                                                               value={(aiResults.businessCity === "Not found") ? "" : aiResults.businessCity || ""}
                                                               onChange={(e) => setAiResults(p => ({
                                                                   ...p,
                                                                   businessCity: e.target.value
                                                               }))}/>
                                                    <TextField label="State" size="small" fullWidth
                                                               value={(aiResults.businessState === "Not found") ? "" : aiResults.businessState || ""}
                                                               onChange={(e) => setAiResults(p => ({
                                                                   ...p,
                                                                   businessState: e.target.value
                                                               }))}/>
                                                    <TextField label="Zip / Postal Code" size="small" fullWidth
                                                               value={(aiResults.businessZip === "Not found") ? "" : aiResults.businessZip || ""}
                                                               onChange={(e) => setAiResults(p => ({
                                                                   ...p,
                                                                   businessZip: e.target.value
                                                               }))}/>
                                                    <TextField label="Country" size="small" fullWidth
                                                               value={(aiResults.businessCountry === "Not found") ? "" : aiResults.businessCountry || ""}
                                                               onChange={(e) => setAiResults(p => ({
                                                                   ...p,
                                                                   businessCountry: e.target.value
                                                               }))}/>
                                                    <TextField label="Business Phone" size="small" fullWidth
                                                               value={(aiResults.businessPhone === "Not found") ? "" : aiResults.businessPhone || ""}
                                                               onChange={(e) => setAiResults(p => ({
                                                                   ...p,
                                                                   businessPhone: e.target.value
                                                               }))}/>
                                                    <TextField label="Business Email" size="small" fullWidth
                                                               value={(aiResults.businessEmail === "Not found") ? "" : aiResults.businessEmail || ""}
                                                               onChange={(e) => setAiResults(p => ({
                                                                   ...p,
                                                                   businessEmail: e.target.value
                                                               }))}/>
                                                    <TextField label="Business Website" size="small" fullWidth
                                                               value={(aiResults.businessWebsite === "Not found") ? "" : aiResults.businessWebsite || ""}
                                                               onChange={(e) => setAiResults(p => ({
                                                                   ...p,
                                                                   businessWebsite: e.target.value
                                                               }))}/>
                                                </Box>
                                            </Box>

                                            {/* GROUP: ADDITIONAL */}
                                            <Box sx={{
                                                p: 2,
                                                bgcolor: '#fff',
                                                borderRadius: '12px',
                                                border: '1px solid #e1e8ed'
                                            }}>
                                                <Typography variant="caption" sx={{
                                                    fontWeight: 900,
                                                    color: '#1976d2',
                                                    letterSpacing: '1px',
                                                    mb: 2,
                                                    display: 'block'
                                                }}>ADDITIONAL</Typography>
                                                <Box sx={{display: 'flex', flexDirection: 'column', gap: 2}}>
                                                    <TextField label="Notes" size="small" fullWidth multiline rows={3}
                                                               value={(aiResults.notes === "Not found") ? "" : aiResults.notes || ""}
                                                               onChange={(e) => setAiResults(p => ({
                                                                   ...p,
                                                                   notes: e.target.value
                                                               }))}/>
                                                </Box>
                                            </Box>

                                        </Box>

                                        <Button
                                            fullWidth variant="contained"
                                            onClick={applyAiDataToReceipt}
                                            sx={{
                                                mt: 3,
                                                py: 1.5,
                                                borderRadius: '10px',
                                                fontWeight: 800,
                                                textTransform: 'none',
                                                bgcolor: '#1976d2'
                                            }}
                                        >
                                            Confirm & Apply All Details
                                        </Button>
                                    </Box>
                                )}
                            </CardContent>
                        </Card>
                    ) : null
                }
                {
                    selectedAction === "Notes" ? (
                        <TextField
                            fullWidth
                            label="Notes"
                            multiline
                            rows={4}
                            value={notes}
                            onChange={(e) => setNotes(e.target.value)}
                        />
                    ) : null
                }
            </CardContent>
        </Card>

    )

}

export default ReceiptsAddNewCard;